import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import axios from "axios";
import { baseURL, handleAxiosError } from "./servicesUtils";
var baseController = "".concat(baseURL, "/rest/mail");
export var sendInfoPremium = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/infoPremium"), data);
    return res.data;
  } catch (err) {
    handleAxiosError(err);
    throw err;
  }
});
export var sendBrochureRequest = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/sendBrochurePremium"), data);
    return res.data;
  } catch (err) {
    handleAxiosError(err);
    throw err;
  }
});
export var sendJobApplicationForm = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/submitJobApplication"), data, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    return res.data;
  } catch (e) {
    handleAxiosError(e);
    throw e;
  }
});
/* Market Report */
export var sendBrochureMR = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/sendBrochureMR"), data);
    return res.data;
  } catch (e) {
    handleAxiosError(e);
    throw e;
  }
});
export var sendInfoMR = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/infoMR"), data);
    return res.data;
  } catch (e) {
    handleAxiosError(e);
    throw e;
  }
});
export var sendExpiredInfoToSales = contractId => __awaiter(void 0, void 0, void 0, function* () {
  try {
    return yield axios.post("".concat(baseController, "/sendExpiredOfferInfoEmailToSales"), {
      contractId: contractId
    });
  } catch (e) {
    handleAxiosError(e);
    throw e;
  }
});